import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 24px;
    height: 100%;
    justify-content: center;
    width: 100%;
  `}
`;

export const OptionsWrapper = styled.ul`
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  list-style-type: none;
  margin: 24px 0px 0px 0px;
  padding: 0px;
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    border-radius: 16px;
    border: 1px solid ${theme.v2.colors.neutral.highLight};
    box-shadow: 0px 4px 4px 0px ${theme.v2.colors.neutral.highLight};
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: flex-start;
    max-width: 264px;
    padding: 24px;
  `}
`;

export const OptionRow = styled.span`
  ${({ theme }) => css`
    align-item: center;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    > button {
      display: block;

      svg {
        fill: ${theme.v2.colors.brand.primaryMedium};
        left: 10px;
        position: relative;
        top: 3px;
      }
    }
  `}
`;

export const OptionTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `};
`;

export const OptionDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    text-align: left;
  `};
`;
